import type { ScheduleReservationResult } from '@/api/proceduresApi'

/**
 * Whether a run reservation created any hold at all.
 *
 * A partial booking still created real holds, so callers invalidate the
 * reservation caches on this BEFORE handling a partial result.
 */
export function reservedAnything(res: ScheduleReservationResult): boolean {
  return res.reserved.length > 0 || res.materials.some(m => m.reserved > 0)
}

/**
 * What to keep on screen after a run reservation, or null when it fully
 * succeeded.
 *
 * Refused rows are not a failure of the action (the booking is partial by
 * design), but closing silently would hide that some machines are still
 * unheld. A material hold that FAILED is its own failure, independent of the
 * machines, and is reported in the same sentence so the operator sees one
 * outcome for the run.
 */
export function reserveOutcomeError(res: ScheduleReservationResult): string | null {
  const materialProblems = res.materials.filter(m => m.message)
  if (res.refused.length === 0 && materialProblems.length === 0) return null
  return [
    res.refused.length > 0 &&
      `${res.reserved.length} reserved, ${res.refused.length} could not be: ` +
        res.refused.map(r => r.message).join(' · '),
    materialProblems.length > 0 &&
      `Material not held: ${materialProblems.map(m => `${m.formName} — ${m.message}`).join(' · ')}`,
  ]
    .filter(Boolean)
    .join('. ')
}
